"use client";

import DocumentInput from "@/components/ui/forms/tailwind/DocumentInput";
import Form from "@/components/ui/forms/tailwind/Form";
import SubmitButton from "@/components/ui/forms/tailwind/SubmitButton";
import { db } from "@/utils/db";
import { useTransition } from "react";
import { useForm } from "react-hook-form";
import { getMemberByDocument } from "./actions";
import { addMemberToOrder, getOrderDraft } from "../checkout/[orderId]/actions";
import Error from "@/components/ui/forms/Error";
import { useRouter } from "next/navigation";
import { toast } from "react-toastify";

const AddMemberForm = ({
  orderId,
  setOpen,
}: {
  orderId?: string;
  setOpen: (open: boolean) => void;
}) => {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const form = useForm({
    defaultValues: {
      document: "",
    },
  });

  const handleSubmit = async (data: { document: string }) => {
    startTransition(async () => {
      const member = await getMemberByDocument(data.document);
      if (!member) {
        form.setError("root", {
          message: "No existe un miembro con este documento.",
        });
        return;
      }

      try {
        const response = await addMemberToOrder({
          memberId: member.id,
          orderId,
        });

        if (response.success) {
          toast.success("¡Agregado a la lista!");
          if (!orderId) router.push(`/anualidad/checkout/${response.orderId}`); //el primero que agrega lo reenvia al listado
          setOpen(false);
        } else {
          form.setError("root", { message: response.error });
        }
      } catch (error: any) {
        console.error(error);
      }
    });
  };

  return (
    <Form methods={form} onSubmit={handleSubmit} className="space-y-6">
      <Error>{form.formState.errors.root?.message}</Error>
      <DocumentInput name="document" />
      <SubmitButton isPending={isPending}>Aceptar</SubmitButton>
    </Form>
  );
};

export default AddMemberForm;
